import { useCallback } from "react";
import { useToggle } from "react-use";

export const useActionProxy = (callback) => {
  const [open, toggle] = useToggle(false);

  const handleCallback = useCallback(
    (atrs) => {
      if (typeof callback === "function") {
        return callback(atrs);
      }
      return null;
    },
    [callback]
  );

  const handleConfirm = useCallback(
    async (...atrs) => {
      const result = await handleCallback(...atrs);
      if (typeof result === "function") {
        toggle(false);
      }
      const formikRef = atrs[1];
      if (formikRef?.current?.setSubmitting) {
        formikRef.current.setSubmitting(false);
      }
    },
    [handleCallback, toggle]
  );

  const handleCancel = useCallback(() => {
    toggle(false);
  }, [toggle]);

  return [open, toggle, handleConfirm, handleCancel];
};
